import { createSelector } from 'reselect';
import { ClassType } from '@lingoda/monolith-graphql';
import studentCreditsSelector from './credits';

export default createSelector(
    studentCreditsSelector,
    (credits) => credits[ClassType.Individual] + credits[ClassType.Group],
);
